import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root {
    /* BACKGROUNDS */
    --bg-orange : #FFB900;
    --bg-darkGrey : #EBEBEB;
    --bg-green : #6BB700;
    /* colors */
    --color-primary : #5B5FC7;
    --color-danger :  #c4314b;
    --color-success :  #237B4B;
    --color-link : #0067B8;
    /* hvoers */
    --color-primary--hover : hsla(349, 60%, 48%, 0.93);
    /* sizes */
    --header-height : 70px;
    /* NEW DESIGN TOKENS */
    --purple: #4A47A3;
    --purple-dark: #3C3489;
    --purple-light: #EEEDFE;
    --green: #1D9E75;
    --green-light: #EAF3DE;
    --green-dark: #0F6E56;
    --red: #DC2626;
    --bg: #FAFAFA;
    --bg-card: #FFFFFF;
    --border: #E4E4E8;
    --border-mid: #D0D0D8;
    --text: #1A1A2E;
    --text-sec: #6B6B80;
    --text-tert: #9999AA;
  }

  * {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    font-family: "Segoe UI","Trebuchet MS", 'Noto Sans', Arial, sans-serif;
  }
  
  body {
    min-height:100vh;
  }
  div:has(> .popup) {
    padding: 0px;
    padding-bottom: 16px;
  }
`;
